'use strict';
var parent = require('../../actual/object/get-own-property-descriptor');

module.exports = parent;



//////////////////
// WEBPACK FOOTER
// ./~/core-js-pure/full/object/get-own-property-descriptor.js
// module id = 633
// module chunks = 13